import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface IProps {
  status: boolean | undefined;
  messageSuccess?: string;
  messageError?: string;
}

const ResultMessage = (props: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const { status, messageSuccess = t`user.settingsSavedSuccess`, messageError = t`user.settingsSavedError` } = props;

  if (status === undefined) {
    return <></>;
  }

  return <Label className={status ? 'success' : 'failure'}>{status ? messageSuccess : messageError}</Label>;
};

export { ResultMessage };

const Label = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  &.success {
    color: #00af46;
  }

  &.failure {
    color: red;
  }
`;
